import { Injectable } from '@angular/core';
import { InvoiceRow } from '../../domain/models/invoice-row.model';
import { InvoiceRowDto } from '../dtos/invoice-row.dto';

@Injectable()
export class InvoiceRowMapper {
  public toInvoiceRow(dto: InvoiceRowDto): InvoiceRow {
    return {
      externalId: dto.ExternalId,
      externalUrl: dto.ExternalUrl,
      invoiceId: dto.InvoiceId,
      patientId: dto.PatientId,
      patientName: dto.PatientName,
      name: dto.Name,
      quantity: dto.Quantity,
      price: dto.Price,
      priceWithVat: dto.PriceWithVat,
      sum: dto.Sum,
      sumVat: dto.SumVat,
      sumTotal: dto.SumTotal,
      prescription: dto.Prescription,
      supervisingVeterinarianId: dto.SupervisingVeterinarianId,
      supervisingVeterinarianName: dto.SupervisingVeterinarianName,
      createdAtUtc: dto.Created,
      modifiedAtUtc: dto.Modified,
    };
  }
}
